import aralLogo from "../assets/organization/Aral_Logo.svg";

const ARAL_CLIENT_ID = Number(process.env.REACT_APP_ARAL_CLIENT_ID);

export const getClientLogo = (clientId: number): JSX.Element | null => {
    switch (clientId) {
        // in the future we can do more clients like SOCAR, Valora, GOFAST
        case ARAL_CLIENT_ID:
            return <img id="client_logo" src={aralLogo} alt="logo" height={28}/>;
        default:
            return null;
    }
}

export const isAralDeClientId = (clientId: number): boolean => {
    return clientId === ARAL_CLIENT_ID;
}